var ExifReader = require("exifreader");

class Exif {

    /**
     * Get exif data for an image
     *
     * @param {ArrayBuffer} data ArrayBuffer (only need the head of the file, first 131072 bytes)
     *
     * @return {Object} Possible keys:
     * {
     *     {number} dateTaken
     *     {number} rotate Possible values: 90, 180, 270
     *     {string} flip Possible value: FLIP_VERTICAL
     * }
     */
    static getExifData (data) {

        var tags = ExifReader.load(data);

        var returnData = {
            dateTaken: null,
            rotate: null,
            flip: null
        };

        var dateTimeOriginal = tags['DateTimeOriginal'];
        if (dateTimeOriginal) {
            returnData.dateTaken = Exif._parseDate(dateTimeOriginal.description);
        }

        var orientation = 1;
        if (tags['Orientation']) {
            orientation = parseInt(tags['Orientation'].value);
        }

        if (orientation) {
            switch (orientation) {
                case 1:
                    break;
                case 2:
                    returnData.flip = 'FLIP_VERTICAL';
                    break;
                case 3:
                    returnData.rotate = 180;
                    break;
                case 4:
                    returnData.rotate = 180;
                    returnData.flip = 'FLIP_VERTICAL';
                    break;
                case 5:
                    returnData.rotate = 90;
                    returnData.flip = 'FLIP_VERTICAL';
                    break;
                case 6:
                    returnData.rotate = 90;
                    break;
                case 7:
                    returnData.rotate = 270;
                    returnData.flip = 'FLIP_VERTICAL';
                    break;
                case 8:
                    returnData.rotate = 270;
                    break;
            }
        }

        return returnData;
    }

    /**
     * Parse date
     *
     * @private
     *
     * @param {string} s
     *
     * @returns {number} Time is sec
     */
    static _parseDate(s) {
        var b = s.split(/\D/);
        var date = Date.UTC(b[0],b[1]-1,b[2],b[3],b[4],b[5]);
        return date/1000;
    }

}

module.exports = Exif;
